import { generateGraph } from '~/util/schema/schemaUtilities'
export function generateSchema({ page = {}, lang = 'en', route = {} }) {
    return {
        '@context': 'https://schema.org',
        '@graph': generateGraph({ page, lang, route })
    }
}
